import styled from "styled-components";
import { green } from "../../styles/variables.style";

export const TarifsWrapper = styled.div`
  .ant-tabs-nav-list {
    margin-left: auto;
    margin-right: auto;
  }
  .ant-tabs-tab {
    font-size: 20px;
  }
  .title {
    text-align: center;
    font-size: 35px;
    margin-top: 50px;
    font-weight: bold;
    color: #2cc84d;
  }

  .ant-tabs-content-holder {
    padding-bottom: 50px;
  }

  .comparatif {
    margin-top: 100px;
    background: #f7f9fa;
    border-radius: 20px;
    display: flex;
    justify-content: space-between;
    padding-left: 15%;
    padding-right: 15%;
    > div {
      .titre {
        font-weight: bold;
        font-size: 35px;
        margin-top: 2%;
      }
      .gauche svg {
        color: red;
      }
      .droite svg {
        color: ${green};
      }
      .txt {
        margin-top: 5px;
        font-size: 22px;
        color: #788896;
        p {
          display: flex;
          align-items: center;
          svg {
            font-size: 22px;
            margin-right: 5px;
            position: relative;
            margin-bottom: -3px;
          }
        }
      }
    }
  }
  .title_rep {
    padding-left: 15%;
    padding-right: 15%;
    font-size: 35px;
    margin-top: 50px;
    font-weight: bold;
  }
  .reponses {
    padding-left: 15%;
    padding-right: 15%;
    display: flex;
    color: #718096;
    .question {
      font-size: 25px;
    }
    .gauche {
      flex: 1;
      padding-right: 2%;
    }
    .droite {
      flex: 1;
      padding-left: 2%;
    }
  }
  .jobs {
    background: #93c9ed;
    margin-top: 150px;
    padding-bottom: 50px;
    padding-top: 20px;
    text-align: center;

    .title {
      font-size: 30px;
      color: black;
      font-weight: bold;
    }
    .txt {
      font-size: 30px;
    }
    .btn {
      margin-left: auto;
      margin-right: auto;
      border-radius: 20px;
      font-size: 25px;
      background: #ffa400;
      height: 50px;
      margin-top: 20px;
      &:hover {
        color: white;
        font-weight: normal;
      }
    }
  }
  @media (max-width: 1024px) {
    .faites {
      margin-top: 0px !important;
    }
    .bande_bleu {
      padding-left: 5px !important;
      padding-right: 5px !important;
    }
    .title {
      padding-left: 0;
      padding-right: 0;
      font-size: 30px;
      text-align: center;
    }
    .suivre i {
      font-size: 16px;
      font-weight: normal;
    }
    .comparatif {
      flex-direction: column;
      margin-top: 10px;
      padding: 10px;

      .gauche {
        .titre {
          margin-left: 0;
        }
        .txt {
          margin-left: 0;
          font-size: 20px;
        }
      }
      .droite {
        .titre {
          margin-left: 0;
        }
        .txt {
          margin-left: 0;
        }
      }
    }
    .title_rep {
      padding-left: 3%;
      padding-right: 3%;
      margin-top: 0;
    }
    .reponses {
      padding-left: 3%;
      padding-right: 3%;
      flex-direction: column;

      .droite,
      .gauche {
        padding-left: 0px;
      }
    }
    .jobs {
      margin-top: 0px;
      .title {
        margin-top: 10px;
      }
    }
  }
`;
